export class ServerURLEnum {
    public static Prod_url: string = 'https://timetrackerbe.aetherti.com/';
    // public static Test_url:string = 'https://testtimetrackerbe.aetherti.com/';
    public static LocalHost_url: string = 'http://localhost:8080/';
    public static AWS_url: string = 'http://43.205.143.57:8080/';
    public static UAT_url: string = 'https://aetherhrms-uat-be.cloudjiffy.net/';

}
